import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getBaseAnalytics: analyticsTypes.GetBaseAnalytics = (params) => {
  return axios.post(`/analytics/base`, params);
};

type QueryFnType = typeof getBaseAnalytics;

type UseGetBaseAnalytics = {
  expertId: string;
  dateFrom: number;
  dateTo: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetBaseAnalytics = ({
  config = {},
  expertId,
  dateFrom,
  dateTo,
}: UseGetBaseAnalytics) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['analytics-base', expertId, dateFrom, dateTo],
    queryFn: () => getBaseAnalytics({ expertId, dateFrom, dateTo }),
    enabled: !!expertId && !!dateFrom && !!dateTo,
    staleTime: 0,
    keepPreviousData: true,
  });
};
